<template>
  <form @submit.prevent="submit">
    <div class="text_large">{{ i18n.trd_create_sell_order({ value: assets.base }) }}</div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <input-field
          class="md-layout-item field__number"
          v-model.trim="form.amount"
          :label="i18n.trd_total_sell({ asset: assets.base })"
          name="order-buy-amount"
          v-validate="'required'"
          type="number"
          step="0.01"
          v-on:focusout.native="roundAmount(assets.base)"
          :errorMessage="allowToValidAmount && lessThanMinimumAmount && currentField === 'amount' ? i18n.trd_validate_minimal_amount({value: getMinimumAmount}) : ''"
        />
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <input-field
          class="md-layout-item field__number"
          v-model.trim="form.price"
          :label="i18n.trd_price_per({ asset: assets.base })"
          name="order-buy-price"
          v-validate="'required'"
          type="number"
          step="0.01"
          v-on:focusout.native="roundPrice(assets.base)"
          :errorMessage="lessThanMinimumPrice && allowToValidPrice && currentField === 'price' ? i18n.trd_validate_minimal_price({value: getMinimumPrice}) : ''"

        />
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <input-field
          class="md-layout-item"
          :value="roundCurrency(form.quoteAmount, assets.quote)"
          :label="i18n.trd_will_receive({ value: assets.quote })"
          name="order-buy-total"
          :disabled="true"
        />
      </div>
    </div>

    <div class="btn-wrap">
      <md-button type="submit" class="btn md-primary"
                 :disabled="isPending || lessThanMinimumAmount || lessThanMinimumPrice">
        {{ i18n.trd_order_sell() }}
      </md-button>
    </div>
  </form>
</template>

<script>
  import InputField from '@com/fields/InputField'
  import FormMixin from '@com/mixins/form.mixin'
  import OrderMakerMixin from '../order-maker.mixin'

  import { confirmAction } from '@js/modals/confirmation_message'
  import { divide, multiply } from '@utils/math.util'
  import { i18n } from '@js/i18n'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import { mapActions, mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import {ErrorHandler} from '@js/errors/error_handler'

export default {
    name: 'trade-orders-sell',
    mixins: [FormMixin, OrderMakerMixin, CurrencyRound],
    components: { InputField },
    props: {
      assets: { type: Object, require: true }
    },
    data () {
      return {
        form: {
          price: undefined,
          amount: undefined,
          quoteAmount: undefined
        },
        allowToValidPrice: false,
        allowToValidAmount: false,
        i18n,
        minValue: 0.000001,
        currentField: ''
      }
    },
    created () {
    },
    computed: {
      ...mapGetters([
        vuexTypes.factorData
      ]),
      lessThanMinimumAmount () {
        return Number(this.form.amount) < this.getMinimumAmount
      },
      lessThanMinimumPrice () {
        return Number(this.form.price) < this.getMinimumPrice
      },
      getMinimumPrice () {
        return this.form.price <= 0 && this.form.amount <= 0 ? this.minValue : divide(this.minValue, this.form.amount)
      },
      getMinimumAmount () {
        return this.form.amount <= 0 && this.form.price <= 0 ? this.minValue : divide(this.minValue, this.form.price)
      }
    },
    methods: {
      ...mapActions({
        updateTwoFactorData: vuexTypes.SET_TWO_FACTOR_STATE
      }),
      roundAmount (quote) {
        this.form.amount = this.roundCurrency(this.form.amount, quote)
      },
      roundPrice (quote) {
        this.form.price = this.roundCurrency(this.form.price, quote)
      },
      getQuoteAmount () {
        this.form.quoteAmount = multiply(this.form.price, this.form.amount)
      },
      async submit () {
        if (!await this.isValid()) return
        if (!await confirmAction()) return
        this.disable()

        try {
          this.allowToValidPrice = true
          this.allowToValidAmount = true
          this.errors.clear()

          const res = await this.createOrder({
            pair: {
              base: this.assets.base,
              quote: this.assets.quote
            },
            baseAmount: this.form.amount,
            quoteAmount: this.form.quoteAmount,
            price: this.form.price,
            isBuy: false
          })

          if (res) {
            this.resetForm()
          }
        } catch (error) {
          ErrorHandler.processUnexpected(error)
        }

        this.enable()
      },
      resetForm () {
        this.form.price = undefined
        this.form.amount = undefined
        setTimeout(() => this.changeAllow(), 0)
      },
      changeAllow () {
        this.allowToValidPrice = false
        this.allowToValidAmount = false
      }
    },
    watch: {
      'form.price' (value) {
        this.getQuoteAmount()
        this.allowToValidPrice = true
        this.currentField = 'price'
      },
      'form.amount' (value) {
        this.getQuoteAmount()
        this.allowToValidAmount = true
        this.currentField = 'amount'
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/components/tradeOrders/TradeOrders.SellOrder.vue